import './Card.css'
import { Link } from 'react-router-dom'

function CardImage({ img }) {
  return (
    <div
      className="card__image"
      style={{
        height: "100%",
        aspectRatio: 1,
        backgroundImage: `url(${img})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        "--card-icon-image": `url(${img})`,
      }}
    />
  )
}

function isExternalLink(link) {
  return /^https?:\/\//i.test(link || '')
}

export default function Card({ title, text, img, link, src }) {
  const external = isExternalLink(link)
  const CardTag = link ? (external ? 'a' : Link) : 'article'
  const cardProps = !link
    ? {}
    : external
      ? { href: link, target: '_blank', rel: 'noreferrer' }
      : { to: link }

  return (
    <CardTag className={link ? 'card card_clickable' : 'card'} {...cardProps}>
      {(img || src) && (
        <div className="card__container">
          {img && <CardImage img={img} />}
          {src && <img src={src} alt="" />}
        </div>
      )}
      <div className="card__body">
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
      {link && <span className="card__more">Подробнее <span aria-hidden="true">↗</span></span>}
    </CardTag>
  )
}
